module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticClass: "parallax"
  }), _vm._v(" "), _c('div', {
    staticClass: "container",
    attrs: {
      "id": "servicesRDV"
    }
  }, [_c('h2', [_vm._v(" Services sur rendez-vous ")]), _vm._v(" "), _c('div', {
    staticClass: "services"
  }, [_c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Chirurgie")]), _vm._v(" "), _c('p', [_vm._v("Chirurgie des tissus mous")]), _vm._v(" "), _c('p', [_vm._v("Ovariectomie")]), _vm._v(" "), _c('p', [_vm._v("Castration")]), _vm._v(" "), _c('p', [_vm._v("Soins dentaires")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Consultation")]), _vm._v(" "), _c('p', [_vm._v("Approche globale basée sur l' "), _c('strong', [_vm._v("alimentation")]), _vm._v(" et le comportement pour\n          atteindre ensemble le "), _c('strong', [_vm._v("bien être")]), _vm._v(" de votre compagnon.")]), _vm._v(" "), _c('p', [_vm._v("Consultations homéopatiques")])]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('h3', [_vm._v("Plateau technique")]), _vm._v(" "), _c('p', [_vm._v("Echograhie")]), _vm._v(" "), _c('p', [_vm._v("Radiographie")]), _vm._v(" "), _c('p', [_vm._v("Hématologie")]), _vm._v(" "), _c('p', [_vm._v("Biochimie")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-140037bc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Fr/ServicesRDV.vue
// module id = 122
// module chunks = 0